import { render, staticRenderFns } from "./room-game-access.vue?vue&type=template&id=35ad7e2b&scoped=true&"
import script from "./room-game-access.vue?vue&type=script&lang=js&"
export * from "./room-game-access.vue?vue&type=script&lang=js&"
import style0 from "./room-game-access.vue?vue&type=style&index=0&id=35ad7e2b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad7e2b",
  null
  
)

export default component.exports